import { Params } from 'router5/types/types/base';

import { GroupOptions, SortOptions } from '@neptune/shared/leaderboard-domain';

import { LeaderboardView } from './leaderboard-view-model';

export function makeLbViewRouteState(
  newParams: Record<string, unknown>,
  routeParams: Params,
  activeView?: Partial<LeaderboardView>,
) {
  if (!routeParams.lbViewUnpacked) {
    /*
     * quick filters updated for the first time - unpack current lb view to url.
     */
    const {
      nameSearchQuery,
      nameSearchMode,
      query,
      sortOptions,
      groupOptions,
      experimentsOnly,
      runsLineage,
      showSelectedHiddenByFilter,
    } = activeView ?? {};

    const emptySortAndGroupOptions: {
      [key in keyof SortOptions | keyof GroupOptions]-?: undefined;
    } = {
      sortBy: undefined,
      sortFieldType: undefined,
      sortFieldAggregationMode: undefined,
      sortDirection: undefined,
      groupBy: undefined,
      groupByFieldType: undefined,
      groupByFieldAggregationMode: undefined,
      openedGroups: undefined,
    };

    return {
      ...routeParams,
      nameSearchQuery,
      nameSearchMode,
      query,
      ...emptySortAndGroupOptions, // Make sure all sort and group options are overwritten.
      ...sortOptions,
      ...groupOptions,
      experimentsOnly,
      showSelectedHiddenByFilter,
      runsLineage,
      ...newParams,
      lbViewUnpacked: true,
    };
  }

  return {
    ...routeParams,
    ...newParams,
  };
}
